import { render, staticRenderFns } from "./consultingcategory.vue?vue&type=template&id=5bb7082d&scoped=true&"
import script from "./consultingcategory.vue?vue&type=script&lang=js&"
export * from "./consultingcategory.vue?vue&type=script&lang=js&"
import style0 from "./consultingcategory.vue?vue&type=style&index=0&id=5bb7082d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb7082d",
  null
  
)

export default component.exports